import { Pipe, PipeTransform, Injectable } from "@angular/core";
import { TranslationService } from "@services/translation.service";

@Pipe({ name: 'enumAsString' })
@Injectable()
export class EnumAsString implements PipeTransform {
    constructor(private translationService: TranslationService) { }

    transform<T>(value: number, type: T, parsedEnum: any): string {
        if (!type[value]) {
            return;
        }

        return this.translationService.tEnum(type, parsedEnum.toString(), value);
    }
}
